import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';
import { kStepColumnWidth, TIMED_OUT, TOKENS } from '../constants';
import { StepStatus } from '../types';
import { SkeletonBar } from './SkeletonBar';
import { StepCircle } from './StepCircle';
import { ViewStatusLabel } from './ViewStatusLabel';

export const ReportProgressStep = memo(
  ({
    label,
    status,
    viewed,
    loading,
    timedOut,
    historyMode,
  }: {
    label: string;
    status: StepStatus;
    viewed: boolean | null;
    loading: boolean;
    timedOut?: boolean;
    historyMode?: boolean;
  }) => {
    const { rpx } = useResponsiveContext();
    const labelColor = timedOut
      ? TIMED_OUT.textSecondary
      : TOKENS.textSecondary;
    return (
      <View
        css={`
          align-items: center;
          flex-shrink: 0;
          width: ${rpx(kStepColumnWidth)}px;
        `}
      >
        <StepCircle
          status={status}
          timedOut={timedOut}
          historyMode={historyMode}
        />

        <Typography.Label
          size={rpx(10)}
          lineHeight={rpx(14)}
          color={labelColor}
          css={`
            margin-top: ${rpx(4)}px;
          `}
        >
          {label}
        </Typography.Label>

        <View
          css={`
            margin-top: ${rpx(2)}px;
            height: ${rpx(12)}px;
            justify-content: center;
          `}
        >
          {loading ? (
            <SkeletonBar width={rpx(36)} height={rpx(8)} />
          ) : (
            <ViewStatusLabel
              status={status}
              viewed={viewed}
              timedOut={timedOut}
              historyMode={historyMode}
            />
          )}
        </View>
      </View>
    );
  },
);
